import type { LocaleMessageBundle } from '../../types'

export const channelFeatureMessages: LocaleMessageBundle = {
  vi: {
    'online.title': 'Bán Online',
    'online.subtitle': 'Cấu hình và theo dõi doanh số bán qua web đặt hàng online.',

    'online.stats.revenue': 'Doanh thu online',
    'online.stats.invoiceCount': 'Số hóa đơn',
    'online.stats.itemQuantity': 'Số món bán',
    'online.stats.avgRevenuePerInvoice': 'Doanh thu TB/đơn',
    'online.stats.liveAmount': 'Đang chờ thanh toán',
    'online.stats.liveItemQuantity': 'Món đang gọi',
    'online.stats.productCount': 'SP đang bán online',
    'online.stats.chart.title': 'Doanh thu bán online theo ngày',
    'online.stats.chart.revenue': 'Doanh thu',
    'online.stats.chart.itemQuantity': 'Số món',
    'online.stats.topProducts': 'Sản phẩm bán chạy',
    'online.stats.topProducts.qty': 'Số lượng',
    'online.stats.topProducts.revenue': 'Doanh thu',
    'online.stats.recentInvoices': 'Hóa đơn gần đây',
    'online.stats.table.invoiceCode': 'Mã hóa đơn',
    'online.stats.table.date': 'Ngày',
    'online.stats.table.status': 'Trạng thái',
    'online.stats.table.total': 'Tổng tiền',
    'online.stats.table.onlineAmount': 'Tiền online',
    'online.stats.table.onlineQty': 'Món online',
    'online.stats.empty': 'Chưa có đơn hàng bán online trong khoảng thời gian này.',

    'online.config.title': 'Tiêu đề',
    'online.config.subtitle': 'Mô tả ngắn',
    'online.config.icon': 'Icon',
    'online.config.iconHint': 'Chọn icon Material Design hiển thị khi chưa có ảnh',
    'online.config.image': 'Ảnh đại diện',
    'online.config.imageHint': 'Ảnh hiển thị trên header web đặt hàng online(tối đa 2MB)',
    'online.config.uploadImage': 'Tải ảnh lên',
    'online.config.removeImage': 'Xóa ảnh',
    'online.config.color': 'Màu chủ đạo',
    'online.config.textColor': 'Màu chữ',
    'online.config.backgroundColor': 'Màu nền',
    'online.config.preview': 'Xem trước web bán online',
    'online.config.previewSubtitle':
      'Cấu hình màu, tiêu đề, ảnh/icon áp dụng trực tiếp lên web đặt hàng online.',
    'online.config.save': 'Lưu cấu hình',
    'online.config.saved': 'Đã lưu cấu hình bán online',
    'online.config.reset': 'Về mặc định',
    'online.config.webviewUrl': 'Link web đặt hàng online',
    'online.config.webviewUrlHint':
      'Link đặt món online theo chi nhánh đang đăng nhập. Link đặt món theo bàn dùng link_code riêng (QR trên bàn).',
    'online.config.webviewUrlCopied': 'Đã copy link webview',

    'online.products.title': 'Sản phẩm bán online',
    'online.products.subtitle':
      'Chọn sản phẩm được phép bán trên webview online. Sản phẩm không chọn sẽ chỉ bán tại quầy.',
    'online.products.product': 'Sản phẩm',
    'online.products.price': 'Giá bán',
    'online.products.online': 'Cho phép bán online',
    'online.products.enableAll': 'Chọn tất cả',
    'online.products.disableAll': 'Bỏ tất cả',
    'online.products.search': 'Tìm sản phẩm',
    'online.products.statusFilter': 'Trạng thái bán online',
    'online.products.statusFilter.all': 'Tất cả',
    'online.products.statusFilter.online': 'Đã bán online',
    'online.products.statusFilter.offline': 'Chưa bán online',
    'online.products.selectedCount': '{count} sản phẩm đang bán online',
    'online.products.branch': 'Chi nhánh',
    'online.products.saved': 'Đã cập nhật sản phẩm bán online',
    'online.products.visible': 'Bán trên kênh',

    'channel.title': 'Kênh bán hàng',
    'channel.subtitle': 'Quản lý các kênh và sản phẩm được phép bán theo từng chi nhánh.',
    'channel.fields.code': 'Mã kênh',
    'channel.fields.name': 'Tên kênh',
    'channel.fields.type': 'Loại kênh',
    'channel.fields.products': 'Sản phẩm',
    'channel.fields.status': 'Trạng thái',
    'channel.fields.note': 'Ghi chú',
    'channel.status.active': 'Đang hoạt động',
    'channel.status.inactive': 'Đã tắt',
    'channel.actions.create': 'Thêm kênh',
    'channel.actions.edit': 'Sửa kênh',
    'channel.actions.configure': 'Cấu hình sản phẩm',
    'channel.products.title': 'Cấu hình sản phẩm theo chi nhánh',
    'channel.products.branch': 'Chi nhánh',
    'channel.products.product': 'Sản phẩm',
    'channel.products.visible': 'Bán trên kênh',
    'channel.delete.title': 'Xóa kênh bán hàng?',
    'channel.delete.message': 'Bạn có chắc muốn xóa kênh này không?',
    'channel.errors.saveFailed': 'Không thể lưu cấu hình bán online',
    'channel.errors.imageUploadFailed': 'Không thể tải ảnh lên, vui lòng thử lại',
    'channel.errors.imageDeleteFailed': 'Không thể xóa ảnh, vui lòng thử lại',
  },
  en: {
    'online.title': 'Online Sales',
    'online.subtitle': 'Configure and track sales made through the online web.',

    'online.stats.revenue': 'Online revenue',
    'online.stats.invoiceCount': 'Invoices',
    'online.stats.itemQuantity': 'Items sold',
    'online.stats.avgRevenuePerInvoice': 'Avg revenue/invoice',
    'online.stats.liveAmount': 'Awaiting payment',
    'online.stats.liveItemQuantity': 'Live ordered items',
    'online.stats.productCount': 'Products selling online',
    'online.stats.chart.title': 'Online revenue by day',
    'online.stats.chart.revenue': 'Revenue',
    'online.stats.chart.itemQuantity': 'Items',
    'online.stats.topProducts': 'Best sellers',
    'online.stats.topProducts.qty': 'Quantity',
    'online.stats.topProducts.revenue': 'Revenue',
    'online.stats.recentInvoices': 'Recent invoices',
    'online.stats.table.invoiceCode': 'Invoice code',
    'online.stats.table.date': 'Date',
    'online.stats.table.status': 'Status',
    'online.stats.table.total': 'Total',
    'online.stats.table.onlineAmount': 'Online amount',
    'online.stats.table.onlineQty': 'Online items',
    'online.stats.empty': 'No online sales in this period.',

    'online.config.title': 'Title',
    'online.config.subtitle': 'Subtitle',
    'online.config.icon': 'Icon',
    'online.config.iconHint': 'Pick a Material Design icon shown when no image is set',
    'online.config.image': 'Image',
    'online.config.imageHint': 'Image displayed on the web đặt hàng online header (max 2MB)',
    'online.config.uploadImage': 'Upload image',
    'online.config.removeImage': 'Remove image',
    'online.config.color': 'Primary color',
    'online.config.textColor': 'Text color',
    'online.config.backgroundColor': 'Background color',
    'online.config.preview': 'Web online preview',
    'online.config.previewSubtitle':
      'Colors, title and image/icon are applied directly to the online ordering web online.',
    'online.config.save': 'Save configuration',
    'online.config.saved': 'Online sales configuration saved',
    'online.config.reset': 'Reset to defaults',
    'online.config.webviewUrl': 'Ordering web link',
    'online.config.webviewUrlHint':
      'Link for online ordering on the current branch. Per-table ordering links use their own link_code (table QR).',
    'online.config.webviewUrlCopied': 'Webview link copied',

    'online.products.title': 'Products selling online',
    'online.products.subtitle':
      'Choose which products can be sold on the online webview. Unselected products are only sold at the counter.',
    'online.products.product': 'Product',
    'online.products.price': 'Price',
    'online.products.online': 'Allow online selling',
    'online.products.enableAll': 'Select all',
    'online.products.disableAll': 'Clear all',
    'online.products.search': 'Search product',
    'online.products.statusFilter': 'Online selling status',
    'online.products.statusFilter.all': 'All',
    'online.products.statusFilter.online': 'Selling online',
    'online.products.statusFilter.offline': 'Not selling online',
    'online.products.selectedCount': '{count} products selling online',
    'online.products.branch': 'Branch',
    'online.products.saved': 'Online products updated',
    'online.products.visible': 'Sell on channel',

    'channel.title': 'Sales channels',
    'channel.subtitle': 'Manage channels and products available for each branch.',
    'channel.fields.code': 'Channel code',
    'channel.fields.name': 'Channel name',
    'channel.fields.type': 'Channel type',
    'channel.fields.products': 'Products',
    'channel.fields.status': 'Status',
    'channel.fields.note': 'Note',
    'channel.status.active': 'Active',
    'channel.status.inactive': 'Inactive',
    'channel.actions.create': 'Add channel',
    'channel.actions.edit': 'Edit channel',
    'channel.actions.configure': 'Configure products',
    'channel.products.title': 'Configure branch products',
    'channel.products.branch': 'Branch',
    'channel.products.product': 'Product',
    'channel.products.visible': 'Sell on channel',
    'channel.delete.title': 'Delete sales channel?',
    'channel.delete.message': 'Are you sure you want to delete this channel?',
    'channel.errors.saveFailed': 'Failed to save online sales configuration',
    'channel.errors.imageUploadFailed': 'Failed to upload image, please try again',
    'channel.errors.imageDeleteFailed': 'Failed to remove image, please try again',
  },
}
